import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * One row per sentence in `@haniverse/sentences`, in the form its author wrote it, never a
 * script-converted twin. That package already keeps one of Tatoeba's simplified/traditional pairs.
 *
 * There is deliberately no `hanzi_script` column. Tatoeba's Mandarin corpus carries no
 * per-sentence script label, so the previous column recorded which opencc direction produced
 * the row rather than a property of the sentence; and storing both directions doubled the row
 * count while still being lossy (one-to-many conversions such as 发 → 發/髮). Traditional text is
 * derived at display time instead.
 */
export const sentenceTable = staticTable(
  "sentence",
  {
    /** The sentence exactly as authored in the source corpus. */
    sentence: text("sentence").notNull(),

    /** The English translation paired with this sentence in the source corpus. */
    translation: text("translation"),
  },
  // Backs the `sentence LIKE '%…%'` example lookup. That scan is superseded by `sentence_word`
  // for word-keyed lookups, but the grapheme-keyed one still needs a substring match.
  (table) => [index("sentence_sentence_idx").on(table.sentence)],
);

export type Sentence = typeof sentenceTable.$inferSelect;
